import React, { useEffect, useState } from "react";
import { Button, Typography, Box, Grid, Autocomplete, InputAdornment, TextField, CircularProgress, Divider } from "@mui/material";
import MyTextField from "../../../components/ui/MyTextField";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Urls } from "../../../api/Urls";
import Api from "../../../api/Api";
import leftArrowIcon from "../../../imgs/imgV2/leftArrowBlack.svg";
import arrowRightIcon from "../../../imgs/imgV2/arrowRightBlavk.svg";
import RechercheIcon from "../../../imgs/imgV2/RechercheIcon.svg";

import MissionComponent from "../../../components/ui/MissionComponent";
import ButtonSquare from "../../../components/ui/ButtonSquare";
import { useLocation } from "react-router-dom";
function ListeMissionInterim() {
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const [search, setSearch] = useState("");
  const [missions, setmissions] = useState([]);
  const location = useLocation();
  const idInt = location.pathname.split("/")[4];
  const nom = location?.state?.nom;
  const prenom = location?.state?.prenom;
  const [status, setStatus] = useState("");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Api.get(Urls.GET_LIST_MISSION, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      params: { ...(search !== "" && { search: search }), ...(status !== "" && { status: status }), interimId: idInt },
    })
      .then((res) => {
        console.log(res, "mission");
        setmissions(res?.data?.missions);
        setData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [search, status]);
  const handlePagination = (link) => {
    console.log("getting data");
    Api.get(`${link}`, {
      headers: { "Content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        setData(res?.data);
        setmissions(res.data?.mission);
      })
      .catch((err) => {
        console.log(err);
        setmissions([]);
      });
  };
  return (
    <Box display="flex" flexDirection="column" gap="24px">
      <Box width="100%">
        <Typography fontSize="28px" fontWeight="700" lineHeight="160%">
          Missions
        </Typography>
        <Typography fontSize="28px" fontWeight="700" lineHeight="160%">
          #{idInt} {prenom} {nom}
        </Typography>
      </Box>
      {/* filter */}
      <Box sx={{ backgroundColor: "#FAFAFB", padding: "40px", borderRadius: "6px" }}>
        <Box>
          <Grid container spacing="16px">
            <Grid item xs={12} md={9}>
              <Box sx={{ marginBottom: "6px" }}>
                <Typography variant="text_normal" fontWeight="600" htmlFor="lieu" name="lieu">
                  Rechercher une mission
                </Typography>
              </Box>
              <MyTextField
                fullWidth
                autoComplete="off"
                type="input"
                placeholder="Rechercher"
                onChange={(event) => {
                  if (event.target.value) {
                    setSearch(event.target.value);
                  } else {
                    setSearch("");
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={RechercheIcon} alt="end" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Box sx={{ marginBottom: "6px" }}>
                <Typography variant="text_normal" fontWeight="600" htmlFor="lieu" name="lieu">
                  État
                </Typography>
              </Box>
              <Autocomplete
                //options={[offerStates]}
                options={[
                  { id: 1, name: "Active", va: "ACTIVE" },
                  { id: 2, name: "Terminée", va: "FINISHED" },
                ]}
                getOptionLabel={(e) => e.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, value) => {
                  if (value !== null) {
                    console.log("selecting offer state value", value);
                    console.log("selecting offer state value", value.id);
                    setStatus(value ? value.va : "");
                    console.log(value);
                    console.log("selectedOfferState");
                  } else {
                    console.log(null);
                    setStatus("");
                  }
                }}
                renderInput={(params) => <TextField {...params} name="autocomplete" placeholder="Tous" />}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      {!loading ? (
        <Box>
          {missions?.map((mission) => (
            <MissionComponent mission={mission} />
          ))}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}
      {missions?.length > 0 && <Divider />}
      {missions?.length === 0 && !loading && <Typography textAlign="center">Aucune mission</Typography>}
      {missions?.length > 0 && !loading && (
        <Box marginBottom="24px" display="flex" alignItems="center" gap="20px" justifyContent="space-between">
          <Box flex={1}>
            {data?.links?.prev && (
              <>
                <Button
                  sx={{ display: { xs: "none", sm: "none", lg: "inherit", md: "inherit" } }}
                  onClick={() => {
                    handlePagination(data?.links?.prev);
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                  variant="mj_secondary_md"
                >
                  <img style={{ marginRight: "8px" }} src={leftArrowIcon} alt="arrow-left" /> Précédent
                </Button>
                <Button
                  sx={{ display: { xs: "inherit", sm: "inherit", lg: "none", md: "none" } }}
                  onClick={() => {
                    handlePagination(data?.links?.prev);

                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                  variant="mj_secondary_md"
                >
                  <img src={leftArrowIcon} alt="arrow-left" />
                </Button>
              </>
            )}
          </Box>
          <Box sx={{ flex: { xs: 8, sm: 8, md: 6, lg: 6 } }} display="flex" gap="10px" justifyContent="center">
            {data?.meta?.links?.map((link, index) => (
              <>
                {index !== 0 && index !== data?.meta?.last_page + 1 && (
                  <ButtonSquare
                    onClick={() => {
                      handlePagination(link.url);
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    action={link?.active ? "number-active" : "number"}
                    number={link.label}
                  />
                )}
              </>
            ))}
          </Box>
          <Box flex={1}>
            {data?.links?.next && (
              <>
                <Button
                  sx={{ display: { xs: "none", sm: "none", lg: "inherit", md: "inherit" } }}
                  onClick={() => {
                    handlePagination(data?.links?.next);
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                  variant="mj_secondary_md"
                >
                  Suivant <img style={{ marginLeft: "8px" }} src={arrowRightIcon} alt="arrow-right" />
                </Button>
                <Button
                  sx={{ display: { xs: "inherit", sm: "inherit", lg: "none", md: "none" } }}
                  onClick={() => {
                    handlePagination(data?.links?.next);
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                  variant="mj_secondary_md"
                >
                  <img src={arrowRightIcon} alt="arrow-right" />
                </Button>
              </>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default ListeMissionInterim;
